import { addInShapeList, generateRectangle } from "../../components/Markup/MarkupFunction";
import reduxStore from "../../configureEnvStore";
import { SHAPE_TYPE, shapeStatus } from "../../constants/Constants";
import { MOUSE_EVENTS, uploadMarkupRootScope } from "../../constants/MarkupConstants";
import { UPLOAD_FILES_DATA } from "../../constants/UploadFilesConstants";
import UploadFileMarkupService from "./UploadFileMarkupService";

class BlurShapeService {
    blurDrawing = (type, o) => {
        let annCanvas = UPLOAD_FILES_DATA.annCanvas;
        if (type === MOUSE_EVENTS.DOWN) {
            //for select and move
            if (annCanvas.findTarget(o.e)) {
                if (annCanvas.findTarget(o.e).localShape == true) {
                    return;
                } // return to select and move if current state
            }
            //required to set
            uploadMarkupRootScope.isResetted = false;
            //reset origin
            UploadFileMarkupService.pointer = annCanvas.getPointer(o.e);
            UploadFileMarkupService.origX = UploadFileMarkupService.pointer.x;
            UploadFileMarkupService.origY = UploadFileMarkupService.pointer.y;
            UploadFileMarkupService.isMovingBlur = false;
            UploadFileMarkupService.isDrawingBlur = true;
            const rectangleFeatures = {
                startX: UploadFileMarkupService.origX,
                startY: UploadFileMarkupService.origY,
                endX: UploadFileMarkupService.pointer.x,
                endY: UploadFileMarkupService.pointer.y,
                color: UPLOAD_FILES_DATA.selectedImageObj.anncolor,
                shapeType: SHAPE_TYPE.BLUR,
                strokeWidth: reduxStore.getState().markup.selectedThicknessForShape,
                isShadow: reduxStore.getState().markup.isShadowOrStroke,
            };
            UploadFileMarkupService.rect = generateRectangle(rectangleFeatures);
            UploadFileMarkupService.rect.set("localShape", true);
            annCanvas.add(UploadFileMarkupService.rect).setActiveObject(UploadFileMarkupService.rect);
        } else if (type === MOUSE_EVENTS.MOVE) {
            if (!UploadFileMarkupService.isDrawingBlur) {
                return;
            } //for move

            if (UploadFileMarkupService.isDrawingBlur) {
                // for draw
                UploadFileMarkupService.rect = annCanvas.getActiveObject();
                UploadFileMarkupService.pointer = annCanvas.getPointer(o.e);
                if (UploadFileMarkupService.origX > UploadFileMarkupService.pointer.x) {
                    UploadFileMarkupService.rect.set({ left: Math.abs(UploadFileMarkupService.pointer.x) });
                }
                if (UploadFileMarkupService.origY > UploadFileMarkupService.pointer.y) {
                    UploadFileMarkupService.rect.set({ top: Math.abs(UploadFileMarkupService.pointer.y) });
                }
                UploadFileMarkupService.rect.set({ width: Math.abs(UploadFileMarkupService.origX - UploadFileMarkupService.pointer.x) });
                UploadFileMarkupService.rect.set({ height: Math.abs(UploadFileMarkupService.origY - UploadFileMarkupService.pointer.y) });
                UploadFileMarkupService.rect.setCoords();
                annCanvas.renderAll();
            }
        } else if (type === MOUSE_EVENTS.UP) {
            if (UploadFileMarkupService.isMovingBlur) {
                //if mouse up after moving
                let newRect = annCanvas.getActiveObject(); //get moved object's new properties
                UploadFileMarkupService.changeMarkupShapeList(newRect); // used for undo redu
                UploadFileMarkupService.isMovingBlur = false;
                UploadFileMarkupService.addShapeCountLog(shapeStatus.MOVE);
            }
            //if mouse up after drawing
            if (UploadFileMarkupService.isDrawingBlur) {
                let newRect = annCanvas.getActiveObject();
                if (newRect.height > 0 && newRect.width > 0) {
                    UploadFileMarkupService.handleShapeCount(1);
                    let dateTime = new Date();
                    const currTimeStamp = dateTime.getTime();
                    newRect.set("id", currTimeStamp);
                    UploadFileMarkupService.pointer = annCanvas.getPointer(o.e);
                    addInShapeList(newRect);
                    UploadFileMarkupService.isDrawingBlur = false;
                    UploadFileMarkupService.addShapeCountLog(shapeStatus.DRAW);
                } else {
                    UploadFileMarkupService.isDrawingBlur = false;
                    annCanvas.remove(newRect);
                }
            }
            UploadFileMarkupService.origX = UploadFileMarkupService.origY = 0;
            UploadFileMarkupService.pointer = null;
        }
    };
}

export default new BlurShapeService();
